import { render, staticRenderFns } from "./profile-company-flow-step.vue?vue&type=template&id=68d31ad8&scoped=true"
import script from "./profile-company-flow-step.vue?vue&type=script&lang=js"
export * from "./profile-company-flow-step.vue?vue&type=script&lang=js"
import style0 from "./profile-company-flow-step.vue?vue&type=style&index=0&id=68d31ad8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d31ad8",
  null
  
)

export default component.exports